const MobileTeam = () => {
  return (
    <div className='flex flex-col items-center space-y-8 pb-8'>
        <div className='w-2/5'>
        <div className='flex flex-col rounded-full overflow-hidden'>
            <img src={"/headshots/bobbypic.webp"} />
        </div>
        <div className='font-display text-navy mt-4'>
            <h1 className='text-center font-bold text-xl'>Robert J. Massey Jr.</h1>
            <h1 className='text-center text-lg'>President & CEO</h1>
        </div>
        </div>
        <div className='w-2/5'>
        <div className='flex flex-col rounded-full overflow-hidden'>
            <img src={"/headshots/phil.webp"} />
        </div>
        <div className='font-display text-navy mt-4'>
            <h1 className='text-center font-bold text-xl'>Philip DeLise</h1>
            <h1 className='text-center text-lg'>Chief Operating Officer</h1>
        </div>
        </div>
        <div className='w-2/5'>
        <div className='flex flex-col rounded-full overflow-hidden'>
            <img src={"/headshots/ezold.webp"} />
        </div>
        <div className='font-display text-navy mt-4'>
            <h1 className='text-center font-bold text-xl'>Rich Ezold Jr.</h1>
            <h1 className='text-center text-lg'>Chief Administrative Officer</h1>
        </div>
        </div>
        <div className='w-2/5'>
        <div className='flex flex-col rounded-full overflow-hidden'>
            <img src={"/headshots/criscuolo.webp"} />
        </div>
        <div className='font-display text-navy mt-4'>
            <h1 className='text-center font-bold text-xl'>Joseph Criscuolo</h1>
            <h1 className='text-center text-lg'>Chief Financial Officer</h1>
        </div>
        </div>
        <div className='w-2/5'>
        <div className='flex flex-col rounded-full overflow-hidden'>
            <img src={"/headshots/essig.webp"} />
        </div>
        <div className='font-display text-navy mt-4'>
            <h1 className='text-center font-bold text-xl'>Don Essig Jr.</h1>
            <h1 className='text-center text-lg'>Vice President of Operations</h1>
        </div>

        </div>
        <div className='w-2/5'>
        <div className='flex flex-col rounded-full overflow-hidden'>
            <img src={"/headshots/vailettenew.webp"} />
        </div>
        <div className='font-display text-navy mt-4'>
            <h1 className='text-center font-bold text-xl'>Chris Vailette Jr.</h1>
            <h1 className='text-center text-lg'>Vice President of Pre-Construction</h1>
        </div>
        </div>
        <div className='w-2/5'>
        <div className='flex flex-col rounded-full overflow-hidden'>
            <img src={"/headshots/jr.webp"} />
        </div>
        <div className='font-display text-navy mt-4'>
            <h1 className='text-center font-bold text-xl'>J.R. LaFrancois</h1>
            <h1 className='text-center text-lg'>Vice President of Metal Panels</h1>
        </div>
        </div>
        <div className='w-2/5'>
        <div className='flex flex-col rounded-full overflow-hidden'>
            <img src={"/headshots/jason.webp"} />
        </div>
        <div className='font-display text-navy mt-4'>
            <h1 className='text-center font-bold text-xl'>Jason McCauley</h1>
            <h1 className='text-center text-lg'>Director of Field Operations</h1>
        </div>
        </div>
    </div>
  )
}

export default MobileTeam